import { cn } from '@repo/tailwind-config/tailwind.functions'
import { tailwindColors } from '@repo/tailwind-config/tailwind.vars'
import Typography from '@repo/ui/typography'
import { ReactNode } from 'react'

type Props = {
  label: string | ReactNode
  data: string | ReactNode
  display?: 'row' | 'column'
  className?: string
}

const LabelWithText = ({ label, data, className, display = 'column' }: Props) => {
  return (
    <div
      className={cn(
        'flex gap-2',
        {
          'flex-col': display === 'column',
          'items-center justify-between': display === 'row'
        },
        className
      )}
    >
      <Typography variant="label-medium" color={tailwindColors.grey.lighter}>
        {label}
      </Typography>
      {typeof data === 'string' || typeof data === 'number' ? (
        <Typography variant="tag" color={tailwindColors.black.DEFAULT}>
          {data}
        </Typography>
      ) : (
        data
      )}
    </div>
  )
}

export default LabelWithText
